module.exports = __webpack_public_path__ + "img/empty-check.b57c9828.svg";